import { Tag } from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import type { NeedSeverity } from 'types/shared'

const SEVERITY_DISPLAY: Record<NeedSeverity, { colour: string; key: string }> =
  {
    high: { colour: 'red', key: 'skillsAndNeeds.severity.high' },
    low: { colour: 'green', key: 'skillsAndNeeds.severity.low' },
    medium: { colour: 'orange', key: 'skillsAndNeeds.severity.medium' }
  }

type NeedSeverityTagProps = {
  severity?: NeedSeverity
  /** Set where nothing else says what the tag is, e.g. outside the Severity table column. */
  withContext?: boolean
  testId?: string
}

export const NeedSeverityTag = ({
  severity,
  withContext = false,
  testId
}: NeedSeverityTagProps) => {
  const { t } = useTranslation()

  if (!severity) {
    return null
  }

  const { colour, key } = SEVERITY_DISPLAY[severity]

  return (
    <StyledTag color={colour} data-testid={testId ?? 'need-severity-tag'}>
      {withContext ? (
        <>
          <VisuallyHidden>
            {t('skillsAndNeeds.severity.accessibleLabel', { level: t(key) })}
          </VisuallyHidden>
          <span aria-hidden="true">{t(key)}</span>
        </>
      ) : (
        t(key)
      )}
    </StyledTag>
  )
}

const StyledTag = styled(Tag)`
  margin: 0;
`

const VisuallyHidden = styled.span`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

export default NeedSeverityTag
